import { forwardRef, useEffect, useState } from "react";
import Cross from "../../assets/svgs/Close.svg";
import SaveSearchModal from "../SavedFilters/SaveSearchModal";

const RightModal = forwardRef(
  (
    {
      isOpen,
      onClose,
      children,
      title,
      desc,
      onFilter,
      from,
      saveSearchFilterData,
      onSetSelectedSaveFilterId,
    },
    ref
  ) => {
    const [showModal, setShowModal] = useState(false);

    const handleClose = () => {
      onClose();
      setShowModal(false);
    };

    /* ✅ SAFE OUTSIDE CLICK HANDLER */
    useEffect(() => {
      if (!isOpen) return;

      const handleClickOutside = (e) => {
        if (!ref?.current) return;

        // 🔥 Ignore react-select dropdown clicks
        if (
          e.target.closest(".react-select__menu") ||
          e.target.closest(".react-select__control")
        ) {
          return;
        }

        // ✅ Close only when clicking outside modal
        if (!ref.current.contains(e.target)) {
          handleClose();
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isOpen, ref]);

    if (!isOpen) return null;

    return (
      <div
        className="fixed inset-0 bg-gray-700 bg-opacity-50 z-[99999]"   // Increased
        style={{ pointerEvents: "none" }}
      >
        <div
          ref={ref}
          className="user-profile open fixed right-0 top-0 h-full bg-white z-[100000]"  // Increased
          style={{ pointerEvents: "auto" }}
        >
          {/* HEADER */}
          <div className="p-6">
            <div className="flex items-center justify-between">
              <p className="head-2 dark-H">{title}</p>
              <img
                role="button"
                src={Cross}
                alt="close"
                onClick={handleClose}
              />
            </div>

            <div className="mt-2">
              <p className="dark-M body-S">{desc}</p>
            </div>

            <hr className="mt-6 border-[#6F6F6F]" />
          </div>

          {/* BODY */}
          <div className="profile-body px-6 py-0 overflow-y-auto pb-12">
            {children}
          </div>

          {/* FOOTER */}
          <div className="light-bg-L filter-button p-6">
            <hr className="mb-6 border-[#6F6F6F]" />

            <div className="flex">
              {from !== "view" && (
                <button
                  type="button"
                  className="save-button light-L head-5 green-bg-H mr-5"
                  onClick={onFilter}
                >
                  Filter
                </button>
              )}
              <button
                type="button"
                onClick={handleClose}
                className="green-H"
              >
                Cancel
              </button>
            </div>
          </div>

          <SaveSearchModal
            from={from}
            showModal={showModal}
            saveSearchFilterData={saveSearchFilterData}
            onSetSelectedSaveFilterId={onSetSelectedSaveFilterId}
            onClose={() => setShowModal(false)}
          />
        </div>
      </div>
    );
  }
);

export default RightModal;